import React from 'react';
import { Button } from '../ui/button';

const iconBtn = { borderRadius: 10, fontSize: '0.8125rem' };

// Header action buttons for the Job Detail page.
export function JobActions({
  jobId, navigate, onSource, onEdit, onShowInsights, onRescore, onRetryStuck, onExport, onAdaptiveInterview, onDistribute,
  rescoring, retrying, stuckCount = 0, candidatesCount, completedCount,
}) {
  return (
    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
      <Button onClick={onDistribute} data-testid="distribute-button"
        style={{ ...iconBtn, borderRadius: 999, background: '#0D9488', color: '#fff', fontWeight: 600 }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}>
          <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
        </svg>
        Post &amp; Share
      </Button>
      <Button onClick={onSource} variant="outline" data-testid="source-candidates-button"
        style={{ ...iconBtn, borderColor: '#0076A3', color: '#0076A3' }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}>
          <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>
        </svg>
        Source Candidates
      </Button>
      <Button onClick={() => navigate(`/jobs/${jobId}/assessments`)} variant="outline" data-testid="assessments-button" style={iconBtn}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}>
          <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/><path d="M9 14l2 2 4-4"/>
        </svg>
        Assessments
      </Button>
      <Button onClick={() => navigate(`/jobs/${jobId}/interviews`)} variant="outline" data-testid="interviews-button" style={iconBtn}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}>
          <polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
        </svg>
        Interviews
      </Button>
      <Button onClick={onAdaptiveInterview} variant="outline" data-testid="adaptive-interview-button" style={{ ...iconBtn, borderColor: '#D97706', color: '#D97706' }}>
        Adaptive Interview
      </Button>
      <Button data-testid="edit-job-button" onClick={onEdit} variant="outline" style={iconBtn}>
        Edit Job
      </Button>
      <Button data-testid="scoring-insights-button" onClick={onShowInsights} variant="outline"
        style={{ ...iconBtn, borderRadius: 999, borderColor: '#005A80', color: '#005A80' }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}>
          <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
        Scoring Insights
      </Button>
      <Button data-testid="rescore-button" onClick={onRescore} disabled={rescoring || candidatesCount === 0} variant="outline" style={iconBtn}>
        {rescoring ? 'Re-scoring...' : 'Re-score All'}
      </Button>
      {stuckCount > 0 && (
        <Button data-testid="retry-stuck-button" onClick={onRetryStuck} disabled={retrying}
          style={{ ...iconBtn, borderRadius: 999, background: retrying ? '#FCD34D' : '#F59E0B', color: '#fff', fontWeight: 600 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}>
            <path d="M23 4v6h-6"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
          </svg>
          {retrying ? 'Retrying...' : `Retry Stuck (${stuckCount})`}
        </Button>
      )}
      <Button data-testid="export-button" onClick={onExport} disabled={completedCount === 0}
        style={{ background: '#0076A3', color: '#fff', borderRadius: 999, fontWeight: 600, fontSize: '0.8125rem' }}>
        Export CSV
      </Button>
    </div>
  );
}
